import { useT } from 'talkr';
import img1 from './img/reviewer-one.jpg';
import img2 from './img/reviewer-two.jpg';
import img3 from './img/reviewer-three.jpg';
import stars1 from './img/stars.png';
import stars1Dark from './img/starsOneDark.png';
import stars2 from './img/starsTwo.png';
import checkTheme from 'utils/custom/checkTheme';

interface IData {
	name: string;
	text: string;
	img: string;
	rating: string;
	starts: string;
}

export const useData = (): IData[] => {
	const { T } = useT();
	const theme = checkTheme();

	return [
		{
			name: 'Joe_88',
			text: 'This app is set up perfectly. Do you have a choice of music to choose from. It chimes in if he wants a while to update you on your progress. I can set your challenge level.',
			img: img1,
			rating: '4.5 / 5.0',
			starts: theme === 'darkMode' ? stars1Dark : stars1,
		},
		{
			name: 'T.Porteous',
			text: T('info_graphic_review_2'),
			img: img2,
			rating: '5.0 / 5.0',
			starts: stars2,
		},
		{
			name: 'Vincent Petroni',
			text: T('info_graphic_review_3'),
			img: img3,
			rating: '4.5 / 5.0',
			starts: theme === 'darkMode' ? stars1Dark : stars1,
		},
	];
};
